import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { cityLinkTitles } from 'config/content';
import ContentLinks from './ContentLinks';

export default function CityLinks({ links, city, ...rest }) {
	const computedLinks = map(links, (uri, key) => ({
		label: `${city} ${cityLinkTitles[key]}`,
		uri,
	}));

	return (
		<ContentLinks
			{...rest}
			columns={1}
			links={computedLinks}
		/>
	);
}

CityLinks.propTypes = {
	links: PropTypes.object,
	city: PropTypes.string,
};
